export default {
  email: "邮箱&nbsp;&nbsp;softdev@zero2ipo.com.cn",
  location: "香港九龙柯士甸道西1号 环球贸易广场15楼1506B室",
};
